import { render, staticRenderFns } from "./HeaderRithual.vue?vue&type=template&id=5d4b25e8&scoped=true&"
import script from "./HeaderRithual.vue?vue&type=script&lang=js&"
export * from "./HeaderRithual.vue?vue&type=script&lang=js&"
import style0 from "./HeaderRithual.vue?vue&type=style&index=0&id=5d4b25e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4b25e8",
  null
  
)

export default component.exports